/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const unitPreferenceJSON = async (): Promise<any> => {
  const {unitPreference, setUnitPreference} = useJSONStore.getState();
  const token = useUserStore.getState().userToken;

  if (Object.keys(unitPreference).length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.unitPreference}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setUnitPreference(res.data);
      })
      .catch((err) => {
        setUnitPreference({});

        return err.message;
      });
  }
};

export default unitPreferenceJSON;
